import type { ReactNode } from 'react';
import './ui.css';

/**
 * La etiqueta redondeada de las celdas: «Servicio», «Activo», «Inactivo».
 *
 * - `marca`: rosado con texto guinda («Servicio»).
 * - `neutro`: gris («Producto», «Inactivo»).
 * - `exito`: verde («Activo»).
 */
export function Chip({
  tono = 'neutro',
  children,
}: {
  tono?: 'marca' | 'neutro' | 'exito';
  children: ReactNode;
}) {
  return <span className={`ui-chip ui-chip--${tono}`}>{children}</span>;
}
